import { render, staticRenderFns } from "./Civil.vue?vue&type=template&id=673590c5"
import script from "./Civil.vue?vue&type=script&lang=js"
export * from "./Civil.vue?vue&type=script&lang=js"
import style0 from "./Civil.vue?vue&type=style&index=0&id=673590c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports